import React, {FunctionComponent} from "react";
import {Colors, Container, MenuTheme, PermanentMenu, BounceLogo, PermanentMenuHeader} from "@bounce/shared/ui";
import {springMenuItems} from "./menu-items";
import {LogoSpring, LogoSpringText} from "bounce-ui/backoffice";
import {urls} from "../../routes/urls";
import {useUser} from "../../contexts";
import {useNavigate} from "react-router-dom";
import {useGetResolutionExpertFullNameByEmail} from "../../apis/requests/backoffice/spring-users-management/getReFullName";
import {queryClient} from "../../apis/ServerApiManager";

const menuTheme: MenuTheme = {
  backgroundColor: Colors.primary._1000,
  selectedBackgroundColor: Colors.primary._800,
  hoverColor: Colors.primary._900,
};

const SpringMenu: FunctionComponent = () => {
  const {agentEmail} = useUser();
  const navigate = useNavigate();
  const {data} = useGetResolutionExpertFullNameByEmail({agentEmail});

  const onSignOut = () => {
    localStorage.clear();
    queryClient.invalidateQueries();
    navigate(urls.backofficeLogin.url);
  };

  const onHomeClick = () => {
    navigate(urls.spring.url);
  };

  return (
    <PermanentMenu
      menuItems={springMenuItems}
      logo={
        <Container row fullWidth sx={{alignItems: "flex-start", paddingLeft: "12px"}}>
          <LogoSpring />
          <LogoSpringText />
        </Container>
      }
      header={
        <PermanentMenuHeader
          type="spring"
          fullName={data?.full_name}
          email={agentEmail}
          onSignOut={onSignOut}
          onHomeClick={onHomeClick}
        />
      }
      footer={
        <Container sx={{justifyContent: "center", padding: "30px"}}>
          <BounceLogo width={"200px"} height={"40px"} />
        </Container>
      }
      menuTheme={menuTheme}
    />
  );
};
export default SpringMenu;
